class CleanupService {
  static escapeString(value: string) {
    return value.replace(/'/g, "''");
  }

  static escapeStringDoubles(value: string) {
    return value.replace(/\\/g, "\\\\").replace(/'/g, "''").replace(/"/g, '\\"');
  }

  static escapeStringArray(values: string[]): string[] {
    return values.map(this.escapeString);
  }

  static cleanByKey(obj: Record<string, unknown>, keys?: string | string[]): Record<string, unknown> {
    const result: Record<string, unknown> = {};

    const keysArray = typeof keys === "string" ? [keys] : keys;

    Object.keys(obj).forEach((key) => {
      const value = obj[key];

      if (!keysArray || keysArray.includes(key)) {
        if (typeof value === "string") {
          result[key] = this.escapeString(value);
        } else if (Array.isArray(value) && value.every((item) => typeof item === "string")) {
          result[key] = this.escapeStringArray(value as string[]);
        } else if (typeof value === "object" && value !== null && !Array.isArray(value)) {
          result[key] = this.cleanByKey(value as Record<string, unknown>, keysArray);
        } else {
          result[key] = value;
        }
      } else {
        result[key] = value;
      }
    });

    return result;
  }

  static cleanByType(obj: Record<string, unknown>): Record<string, unknown> {
    const result: Record<string, unknown> = {};

    Object.keys(obj).forEach((key) => {
      const value = obj[key];

      if (typeof value === "string") {
        result[key] = this.escapeString(value);
      } else if (Array.isArray(value) && value.every((item) => typeof item === "string")) {
        result[key] = this.escapeStringArray(value as string[]);
      } else if (typeof value === "object" && value !== null && !Array.isArray(value)) {
        result[key] = this.cleanByType(value as Record<string, unknown>);
      } else {
        result[key] = value;
      }
    });

    return result;
  }

  static stripEmpty<T>(obj: T): T {
    if (Array.isArray(obj)) {
      return obj
        .map((item) => (typeof item === "object" && item !== null ? this.stripEmpty(item) : item))
        .filter((item) => {
          if (item === null || item === "") return false;
          if (Array.isArray(item) && item.length === 0) return false;
          if (typeof item === "object" && item !== null && Object.keys(item).length === 0) {
            return false;
          }
          return true;
        }) as unknown as T;
    }

    if (typeof obj === "object" && obj !== null) {
      const result: Partial<T> = {};

      for (const [key, value] of Object.entries(obj) as [keyof T, unknown][]) {
        if (
          value === null ||
          value === "" ||
          (Array.isArray(value) && value.length === 0) ||
          (typeof value === "object" && !Array.isArray(value) && value !== null && Object.keys(value).length === 0)
        ) {
          continue;
        }

        if (typeof value === "object" && value !== null) {
          const nested = this.stripEmpty(value as object);
          if (!(typeof nested === "object" && nested !== null && Object.keys(nested).length === 0)) {
            result[key] = nested as unknown as T[keyof T];
          }
        } else {
          result[key] = value as unknown as T[keyof T];
        }
      }

      return result as T;
    }

    return obj;
  }
}

export default CleanupService;
